module.exports = __webpack_public_path__ + "assets/img/3_1206.8974cc6d.jpg";